import React from 'react';
import { compose } from 'recompose';
import Layout from '../utils/layout';
import { graphql } from 'gatsby';
import {
  withAuthorization,
  withEmailVerification,
} from '../utils/Session';
import Support from '../components/scenes/Support/Support';

const condition = authUser => !!authUser;
const SupportPage = compose(
  withEmailVerification,
  withAuthorization(condition),
)(Support);

export default () => {
  return (
    <Layout>
      <SupportPage />
    </Layout>
  );
};

export const query = graphql`
  query SupportSeo {
    site {
      siteMetadata {
        home {
          defaultTitle: title
          titleTemplate
          defaultDescription: description
          siteUrl: url
          defaultImage: image
          twitterUsername
        }
      }
    }
  }
`;
